import { render, staticRenderFns } from "./SuppliersSelector.vue?vue&type=template&id=c3fce586"
import script from "./SuppliersSelector.vue?vue&type=script&lang=js"
export * from "./SuppliersSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports